import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(to right, #f0f0f0 8%, #f5f5f5 18%, #f0f0f0 33%);
  background-size: 800px 100px;
  animation: ${shimmer} 1.5s linear infinite;
  border-radius: 4px;
`;

const SkeletonCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const SkeletonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => props.marginBottom || '12px'};
`;

const SkeletonLine = styled(SkeletonBase)`
  height: ${(props) => props.height || '16px'};
  width: ${(props) => props.width || '100%'};
`;

const SkeletonHeader = styled(SkeletonBase)`
  height: 32px;
  width: 180px;
  margin-bottom: 8px;
`;

const SkeletonSubheader = styled(SkeletonBase)`
  height: 18px;
  width: 140px;
  margin-bottom: 24px;
`;

const SkeletonImage = styled(SkeletonBase)`
  width: 80px;
  height: 80px;
  border-radius: 4px;
  flex-shrink: 0;
`;

const ItemRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

const ItemDetails = styled.div`
  flex: 1;
`;

const OrderDetailSkeleton = () => {
  return (
    <div>
      <SkeletonLine
        width="100px"
        height="14px"
        style={{ marginBottom: '16px' }}
      />

      <SkeletonHeader />
      <SkeletonSubheader />

      {/* Order Info Card */}
      <SkeletonCard>
        <SkeletonRow>
          <SkeletonLine width="100px" height="14px" />
          <SkeletonLine width="120px" height="14px" />
        </SkeletonRow>
        <SkeletonRow marginBottom="0">
          <SkeletonLine width="80px" height="14px" />
          <SkeletonLine width="100px" height="14px" />
        </SkeletonRow>
      </SkeletonCard>

      {/* Student Section */}
      <SkeletonCard>
        <SkeletonLine
          width="140px"
          height="20px"
          style={{ marginBottom: '16px' }}
        />

        {[1, 2].map((i) => (
          <ItemRow key={i}>
            <SkeletonImage />
            <ItemDetails>
              <SkeletonLine
                width="180px"
                height="16px"
                style={{ marginBottom: '8px' }}
              />
              <SkeletonLine
                width="100px"
                height="14px"
                style={{ marginBottom: '8px' }}
              />
              <SkeletonLine width="60px" height="14px" />
            </ItemDetails>
          </ItemRow>
        ))}
      </SkeletonCard>

      {/* Totals Section */}
      <SkeletonCard>
        <SkeletonLine
          width="100px"
          height="18px"
          style={{ marginBottom: '16px' }}
        />
        {[1, 2, 3, 4].map((i) => (
          <SkeletonRow key={i} marginBottom="8px">
            <SkeletonLine width="80px" height="14px" />
            <SkeletonLine width="60px" height="14px" />
          </SkeletonRow>
        ))}
        <SkeletonRow
          marginBottom="0"
          style={{
            borderTop: '1px solid #eee',
            paddingTop: '12px',
            marginTop: '8px',
          }}
        >
          <SkeletonLine width="60px" height="18px" />
          <SkeletonLine width="80px" height="18px" />
        </SkeletonRow>
      </SkeletonCard>
    </div>
  );
};

export default OrderDetailSkeleton;
